export type NOTIFICATION_HAS_ERRORED = typeof NOTIFICATION_HAS_ERRORED
export const NOTIFICATION_HAS_ERRORED = '[Notifications] NOTIFICATION_HAS_ERRORED'

export type GET_NOTIFICATIONS = typeof GET_NOTIFICATIONS
export const GET_NOTIFICATIONS = '[Notifications] GET_NOTIFICATIONS'

export const GET_NOTIFICATIONS_SUCCESS = '[Notifications] GET_NOTIFICATIONS_SUCCESS'
export type GET_NOTIFICATIONS_SUCCESS = typeof GET_NOTIFICATIONS_SUCCESS

export type UPDATE_NOTIFICATION = typeof UPDATE_NOTIFICATION
export const UPDATE_NOTIFICATION = '[Notifications] UPDATE_NOTIFICATION'

export const UPDATE_NOTIFICATION_SUCCESS = '[Notifications] UPDATE_NOTIFICATION_SUCCESS'
export type UPDATE_NOTIFICATION_SUCCESS = typeof UPDATE_NOTIFICATION_SUCCESS

export type DELETE_NOTIFICATION = typeof DELETE_NOTIFICATION
export const DELETE_NOTIFICATION = '[Notifications] DELETE_NOTIFICATION'

export const DELETE_NOTIFICATION_SUCCESS = '[Notifications] DELETE_NOTIFICATION_SUCCESS'
export type DELETE_NOTIFICATION_SUCCESS = typeof DELETE_NOTIFICATION_SUCCESS
